module.exports = __webpack_public_path__ + "assets-cabinet/img/iconRight.12d7926b.svg";